import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import {jwtDecode} from "jwt-decode"; 

const ProtectedRoute = () => {
  const token = Cookies.get("token");

  if (!token) return <Navigate to="/" />; 
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000); 

    if (decodedToken.exp < currentTime) {
      Cookies.remove("token"); 
      Cookies.remove("userId");
      return <Navigate to="/" />; 
    }

    return <Outlet />; 
  } catch (error) {
    Cookies.remove("token"); 
    Cookies.remove("userId");
    return <Navigate to="/" />; 
  }
};

export default ProtectedRoute;
